import { useCallback, useState } from 'react';

export interface CreateCampaignState {
  name: string;
  isValid: boolean;
}

export const useCreateCampaignState = (): { state: CreateCampaignState; setName: (name: string) => void } => {
  const [name, setName] = useState('');
  const [isValid, setIsValid] = useState(false);

  const onSetName = useCallback((newName: string) => {
    if (newName.length < 5 || newName.length > 100) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }

    setName(newName ?? '');
  }, []);

  return { state: { name, isValid }, setName: onSetName };
};
